(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shared-walking-weekends"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shared-walking-weekends')) {
    customElements.define('shared-walking-weekends', class extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;

        try {
          this.config = JSON.parse(this.dataset.config);
          this.text = this.config.text;
          this.config.dates = this.buildDates();
          this.invitation = this.readInvitation(new URLSearchParams(location.search));

          if (!this.invitation) return;

          this.today = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Pacific/Auckland',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }).formatToParts(new Date()).reduce((parts, part) => {
            parts[part.type] = part.value;
            return parts;
          }, {});

          this.today = `${this.today.year}-${this.today.month}-${this.today.day}`;

          this.querySelector('[data-checkout]').addEventListener('click', () => this.checkout());
          this.render();
          this.querySelector('[data-gate]').hidden = true;
          this.querySelector('[data-content]').hidden = false;
        } catch (error) {
          this.querySelector('[data-gate]').hidden = false;
          this.querySelector('[data-content]').hidden = true;
          if (this.config?.editor) console.warn('Shared weekends:', error);
        }
      }

      buildDates() {
        const seasonYear = Number(this.config.seasonStartYear);

        if (!Number.isInteger(seasonYear) || seasonYear < 2000 || seasonYear > 2100) return [];

        const months = {
          jan: 1, january: 1, feb: 2, february: 2, mar: 3, march: 3,
          apr: 4, april: 4, may: 5, jun: 6, june: 6, jul: 7, july: 7,
          aug: 8, august: 8, sep: 9, sept: 9, september: 9,
          oct: 10, october: 10, nov: 11, november: 11, dec: 12, december: 12
        };

        // Approved shared dates for the November 2026–May 2027 season.
        // Other product variants never become eligible just because stock changes.
        const approved = {
          christmas: ['58075251999023', '58075252064559', '52010462642479'],
          summer: ['52010462675247', '58075252293935'],
          april: ['52010466279727'],
          may: ['52010466312495', '52010466345263', '52010466378031', '52010466410799']
        };

        if (String(this.config.productId) !== '10556397093167') return [];

        return this.config.variants.flatMap(variant => {
          const approvedWindow = Object.keys(approved).find(window => approved[window].includes(String(variant.key)));
          if (!approvedWindow) return [];

          const title = String(variant.title || '').trim();
          const iso = title.match(/^(\d{4})-(\d{2})-(\d{2})$/);
          const monthFirst = title.match(/^([a-z]+)\.?\s+(\d{1,2})(?:st|nd|rd|th)?(?:,?\s+(\d{4}))?$/i);
          const dayFirst = title.match(/^(\d{1,2})(?:st|nd|rd|th)?\s+([a-z]+)\.?(?:,?\s+(\d{4}))?$/i);

          let year, month, day;

          if (iso) {
            year = Number(iso[1]);
            month = Number(iso[2]);
            day = Number(iso[3]);
          } else if (monthFirst || dayFirst) {
            const match = monthFirst || dayFirst;
            month = months[(monthFirst ? match[1] : match[2]).toLowerCase()];
            day = Number(monthFirst ? match[2] : match[1]);
            year = match[3] ? Number(match[3]) : seasonYear + (month < 11 ? 1 : 0);
          } else {
            return [];
          }

          const date = new Date(Date.UTC(year, month - 1, day));

          if (Number.isNaN(date.getTime()) || date.getUTCFullYear() !== year ||
              date.getUTCMonth() + 1 !== month || date.getUTCDate() !== day ||
              date.getUTCDay() !== 4) return [];

          const inSeason = (year === seasonYear && month >= 11) ||
            (year === seasonYear + 1 && month <= 5);

          if (!inSeason) return [];

          let window;

          if (month === 11 || (month === 12 && day < 25)) window = 'christmas';
          else if (month === 1 || month === 2) window = 'summer';
          else if (month === 4) window = 'april';
          else if (month === 5) window = 'may';
          else return [];

          if (window !== approvedWindow) return [];

          const departure = new Date(date);
          departure.setUTCDate(departure.getUTCDate() + 3);

          const formatter = new Intl.DateTimeFormat('en-NZ', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC'
          });

          const label = formatter.formatRange
            ? formatter.formatRange(date, departure)
            : `${formatter.format(date)} – ${formatter.format(departure)}`;

          return [{
            ...variant,
            arrival: date.toISOString().slice(0, 10),
            window,
            label
          }];
        }).sort((a, b) => a.arrival.localeCompare(b.arrival));
      }

      normalise(value) {
        const key = String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[–—_-]/g, ' ')
          .replace(/\s+/g, ' ');

        if (!key || ['no other window suits', 'no other date suits', 'none'].includes(key)) return '';

        const aliases = {
          'before christmas': 'christmas',
          'christmas': 'christmas',
          'mid summer': 'summer',
          'summer': 'summer',
          'early april': 'april',
          'late april': 'april',
          'april': 'april',
          'may': 'may'
        };

        return aliases[key] || null;
      }

      readInvitation(params) {
        const keys = ['qty', 'pref1', 'pref2', 'pref3'];
        const hasInvitation = keys.some(key => params.has(key));

        let qtyValue;
        let preferences;

        if (this.config.editor && !hasInvitation) {
          qtyValue = String(this.config.previewQty);
          preferences = this.config.previewPreferences;
        } else {
          if (keys.some(key => params.getAll(key).length > 1)) return null;
          qtyValue = params.get('qty') || '';
          preferences = keys.slice(1).map(key => params.get(key) || '');
        }

        if (!/^(?:[2-9]|10)$/.test(qtyValue)) return null;

        const windows = preferences.map(value => this.normalise(value));
        if (!windows[0] || windows.some(value => value === null)) return null;

        const seen = new Set();
        const choices = [];

        windows.forEach((window, index) => {
          if (!window || seen.has(window)) return;
          seen.add(window);
          choices.push({ window, index });
        });

        return { qty: Number(qtyValue), choices };
      }

      state(date) {
        if (!date) return 'unverified';

        const parsed = new Date(`${date.arrival}T00:00:00Z`);

        if (!/^\d{4}-\d{2}-\d{2}$/.test(date.arrival) || Number.isNaN(parsed.getTime()) ||
            parsed.toISOString().slice(0, 10) !== date.arrival || parsed.getUTCDay() !== 4) return 'unverified';

        if (date.arrival <= this.today || ['exclusive', 'private', 'closed'].includes(String(date.mode || '').trim().toLowerCase())) return 'unavailable';

        if (!date.tracked || !date.denyOverselling || !Number.isInteger(date.deposit) || date.deposit <= 0 ||
            !Number.isInteger(date.remaining) || date.remaining < 0 || date.remaining > 10) return 'unverified';

        if (date.remaining === 0) return 'full';
        if (!date.available) return 'unavailable';

        if (!['', 'shared', 'unallocated'].includes(String(date.mode || '').trim().toLowerCase())) return 'unverified';

        return date.remaining >= this.invitation.qty ? 'fits' : 'insufficient';
      }

      pick(window) {
        const candidates = this.config.dates
          .filter(date => date.window === window)
          .sort((a, b) => a.arrival.localeCompare(b.arrival));

        const fits = candidates.filter(date => this.state(date) === 'fits');

        return fits.find(date => date.remaining < 10) || fits[0] ||
          candidates.find(date => this.state(date) === 'insufficient') ||
          candidates.find(date => this.state(date) === 'unverified') ||
          candidates.find(date => this.state(date) === 'full') || candidates[0];
      }

      message(key) {
        return String(this.text[key] || '').replaceAll('[X]', String(this.invitation.qty));
      }

      element(tag, className, text) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text) element.textContent = text;
        return element;
      }

      render() {
        this.selectedDate = null;
        this.querySelector('[data-summary]').hidden = true;
        this.querySelector('[data-checkout]').disabled = true;

        const cards = this.querySelector('[data-cards]');
        cards.replaceChildren();

        this.querySelector('[data-party]').textContent = this.message('party');
        this.buttons = [];

        let available = 0;
        let unverified = false;

        this.invitation.choices.forEach(choice => {
          const date = this.pick(choice.window);
          const state = this.state(date);

          if (state === 'unverified') unverified = true;

          const card = this.element('article', 'swb__card');
          card.append(this.element('p', 'swb__option subheading', this.text.options[choice.index]));

          const title = this.element('h2', 'h4', date?.label || this.text.noDates);
          title.id = `${this.id}-option-${choice.index}`;
          card.setAttribute('aria-labelledby', title.id);
          card.append(title);

          const availability = this.element('div', 'swb__availability');

          if (state !== 'fits') {
            availability.append(this.element('strong', '', this.message(state)));
          }

          const detailKey = {
            full: 'fullDetail',
            insufficient: 'insufficientDetail',
            unavailable: 'unavailableDetail'
          }[state];

          if (detailKey) {
            availability.append(this.element('p', '', this.message(detailKey)));
          }

          card.append(availability);

          const button = this.element(
            'button',
            'swb__button button',
            state === 'fits' ? this.text.choose : this.message(state)
          );

          button.type = 'button';
          button.disabled = state !== 'fits';

          if (!button.disabled) {
            available++;
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-label', `${this.text.choose}: ${date.label}`);
            button.addEventListener('click', () => this.select(date, card, button));
            this.buttons.push({ card, button });
          }

          card.append(button);
          cards.append(card);
        });

        this.querySelector('[data-status]').textContent = available
          ? ''
          : (unverified ? this.text.availabilityIssue : this.text.noOptions);
      }

      select(date, selectedCard, selectedButton) {
        if (this.busy || this.state(date) !== 'fits') return;

        this.selectedDate = date;
        this.querySelector('[data-cart-help]').hidden = true;

        this.buttons.forEach(({ card, button }) => {
          const selected = button === selectedButton;
          card.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.textContent = selected ? this.text.selected : this.text.choose;
        });

        this.querySelector('[data-selected-date]').textContent = date.label;
        this.querySelector('[data-selected-party]').textContent = this.message('party');

        this.querySelector('[data-total]').textContent = new Intl.NumberFormat('en-NZ', {
          style: 'currency',
          currency: 'NZD',
          currencyDisplay: 'code'
        }).format(Number(this.config.price) * this.invitation.qty);

        this.querySelector('[data-deposit]').textContent = new Intl.NumberFormat('en-NZ', {
          style: 'currency',
          currency: 'NZD',
          currencyDisplay: 'code'
        }).format(date.deposit * this.invitation.qty / 100);

        this.querySelector('[data-checkout]').disabled = Boolean(this.config.editor);
        this.querySelector('[data-summary]').hidden = false;
        this.querySelector('[data-status]').textContent = this.text.selection.replace('[DATE]', date.label);
      }

      route(path) {
        return `${this.config.rootUrl.replace(/\/?$/, '/')}${path}`;
      }

      async refreshAvailability() {
        const url = new URL(location.href);
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', this.config.sectionId);
        url.searchParams.set('_swb_refresh', Date.now().toString());

        const response = await fetch(url, {
          credentials: 'same-origin',
          cache: 'no-store'
        });

        if (!response.ok) throw new Error('Availability request failed');

        const sections = await response.json();
        const html = sections[this.config.sectionId];

        if (typeof html !== 'string' || !html) throw new Error('Section unavailable');

        const document = new DOMParser().parseFromString(html, 'text/html');
        const element = document.getElementById(this.id);
        const fresh = element && JSON.parse(element.dataset.config);

        if (!fresh || String(fresh.productId) !== String(this.config.productId) ||
            fresh.sectionId !== this.config.sectionId || !Array.isArray(fresh.variants)) {
          throw new Error('Invalid availability response');
        }

        this.config.variants = fresh.variants;
        this.config.price = fresh.price;
        this.config.seasonStartYear = fresh.seasonStartYear;
        this.config.dates = this.buildDates();

        // Recheck today's date for pages left open overnight.
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Pacific/Auckland',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).formatToParts(new Date()).reduce((result, part) => {
          result[part.type] = part.value;
          return result;
        }, {});

        this.today = `${parts.year}-${parts.month}-${parts.day}`;
      }

      async readCart() {
        const response = await fetch(this.route('cart.js'), {
          credentials: 'same-origin',
          cache: 'no-store'
        });

        if (!response.ok) throw new Error('Cart request failed');

        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');

        return cart;
      }

      cartState(cart, date) {
        const bookings = cart.items.filter(item => String(item.product_id) === String(this.config.productId));

        if (!bookings.length) return 'empty';

        if (bookings.length === 1 && String(bookings[0].variant_id) === String(date.key) &&
            bookings[0].quantity === this.invitation.qty && !bookings[0].properties?.['Booking type'] &&
            !bookings[0].properties?.['_Booking type'] &&
            !bookings[0].properties?.['_walks-booking']) {
          return 'matches';
        }

        return 'conflict';
      }

      async checkout() {
        if (this.busy || this.config.editor || !this.invitation || !this.selectedDate) return;

        const chosen = this.selectedDate;
        const previousPrice = this.config.price;
        this.busy = true;

        const button = this.querySelector('[data-checkout]');
        const status = this.querySelector('[data-status]');

        button.disabled = true;
        button.textContent = this.text.checking;
        this.setAttribute('aria-busy', 'true');
        this.querySelector('[data-cart-help]').hidden = true;
        this.buttons.forEach(item => { item.button.disabled = true; });

        try {
          await this.refreshAvailability();

          const date = this.config.dates.find(item => item.key === chosen.key);

          if (!date || this.state(date) !== 'fits' || date.arrival !== chosen.arrival) {
            this.render();
            status.textContent = this.text.changed;
            return;
          }

          if (date.deposit !== chosen.deposit || this.config.price !== previousPrice) {
            this.render();
            status.textContent = this.text.priceChanged;
            return;
          }

          const cart = await this.readCart();
          const cartState = this.cartState(cart, date);

          if (cartState === 'conflict') {
            status.textContent = this.text.cartConflict;
            this.querySelector('[data-cart-help]').hidden = false;
            return;
          }

          if (cartState === 'empty') {
            const response = await fetch(this.route('cart/add.js'), {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: Number(date.key),
                  quantity: this.invitation.qty
                }]
              })
            });

            if (!response.ok) throw new Error('Could not add booking');

            // Verify the whole booking before redirecting; never clear someone else's cart.
            if (this.cartState(await this.readCart(), date) !== 'matches') throw new Error('Cart changed');
          }

          window.location.assign(this.route('checkout'));
        } catch (error) {
          status.textContent = this.text.checkoutError;
          this.querySelector('[data-cart-help]').hidden = false;
          if (this.config.editor) console.warn('Shared checkout:', error);
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          button.textContent = this.text.continue;
          button.disabled = !this.selectedDate || Boolean(this.config.editor);
          this.buttons.forEach(item => { item.button.disabled = false; });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
